import { render, staticRenderFns } from "./search-on-tinder.vue?vue&type=template&id=17a12b9c"
import script from "./search-on-tinder.vue?vue&type=script&lang=js"
export * from "./search-on-tinder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navigation: require('/app/components/Navigation.vue').default,FooterMain: require('/app/components/FooterMain.vue').default})
